import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AddEditJobModal = (props: { active: boolean, closeHandler: any, edit:boolean, title:string,isTeacher:boolean, id:number, onDone:any }) => {
    const titleId = useId();
    const [title,setTitle] = useState('');
    const [isTeacher,setIsTeacher] = useState(false);
    const [titleErr,setTitleErr] = useState(false);
    useEffect(() => {
        const isActive = props.active;
        const edit = props.edit;
        const _title = props.title;
        const _isTeacher = props.isTeacher;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if(edit){
                setTitle(_title);
                setIsTeacher(_isTeacher);
            } else {
                setTitle('');
                setIsTeacher(false);
            }
            setTitleErr(false);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const data = {
            title:title.trim(),
            isTeacher:isTeacher ? '1' : '0',
            id:props.id.toString(),
        };
        const edit = props.edit;
        if(data.title.length < 2){
            setTitleErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/jobs/' + (edit ? 'edit':'add'),
            data,
            true,
            (d: {
                result: string,
                reason: string,
                id:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    edit ? 'شغل ویرایش شد.' : 'شغل جدید افزوده شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش شغل' : 'افزودن شغل'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={titleId}>عنوان شغل:</label>
                        <input type="text"
                               id={titleId}
                               className={"form-control" + (titleErr ? ' is-invalid' : '')}
                               value={title}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTitle(t);
                                   setTitleErr(false);
                               }}
                        />
                        <div className={"invalid-feedback" + (titleErr ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label>آیا شغل مربوط به معلم‌ها است؟</label>
                        <button className={"techaran-radio-box" + (isTeacher ? ' active' : '')} onClick={()=>setIsTeacher(true)}>
                            <div><i/></div>
                            <span>بله، معلم است.</span>
                        </button>
                        <button className={"techaran-radio-box" + (!isTeacher ? ' active' : '')}
                                onClick={() => setIsTeacher(false)}>
                            <div><i/></div>
                            <span>خیر، معلم نیست.</span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:10,marginTop:20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};